import { useDispatch } from 'react-redux';
import { displayAlert } from 'redux-implementations/alerts';
import { AppDispatch } from 'redux-implementations/makeStore';
import { AlertTypes } from 'types/State';

interface Options {
  alertTime?: number;
  debug?: string;
}

export function useAlert(): {
  showError: (message: string, options: Options) => void;
} {
  const dispatch = useDispatch<AppDispatch>();

  function showError(message: string, { alertTime = 5000, debug }: Options): void {
    dispatch<any>(
      displayAlert({
        type: AlertTypes.Error,
        message,
        alertTime,
        debug,
      })
    );
  }

  return { showError };
}
